import { render, staticRenderFns } from "./ScrollingColumn.vue?vue&type=template&id=227d15e5&scoped=true&"
import script from "./ScrollingColumn.vue?vue&type=script&lang=ts&"
export * from "./ScrollingColumn.vue?vue&type=script&lang=ts&"
import style0 from "./ScrollingColumn.vue?vue&type=style&index=0&id=227d15e5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227d15e5",
  null
  
)

export default component.exports